export class Month {
    static January = 1;
    static February = 2;
    static March = 3;
    static April = 4;
    static May = 5;
    static June = 6;
    static July = 7;
    static August = 8;
    static September = 9;
    static October = 10;
    static November = 11;
    static December = 12;


    value: number;
    displayName: string;
    constructor(value, displayName) {
        this.value = value;
        this.displayName = displayName;
    }
}